import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import BannerDetails from "../../assets/banner-detail.png";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Contentimg from "../../assets/content-img.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdCall } from "react-icons/md";
import Relateddeals from "../RelatedDeals/RelatedDeals";
import OtherDeals from "../OtherDeals/OtherDeals";
import { OtherDealsApi } from "../../Utils/Api/OtherDealsApi";
import { VoucherDetailsApi } from "../../Utils/Api/VoucherDetailsApi";
import { RelatedDealsApi } from "../../Utils/Api/RelatedDealsApi";
import { useEffect } from "react";
import Loader from "../../Components/Loader/Loader";

const VoucherDetails = (props) => {
  const parameter = useParams();
  const voucherId = parseInt(parameter.id);
  const [voucherdetail, setVoucherdetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [otherdeals, setOtherdeals] = useState([]);
  const [relateddeals, setRelateddeals] = useState([]);

  const navigate = useNavigate();

  const OtherDealsHandler = async () => {
    const data = {
      voucherId: parseInt(voucherId),
      city_id: 1, //hardcoded
    };
    const otherdealsData = await OtherDealsApi(data, () => {
      navigate("/");
    });
    setOtherdeals(otherdealsData.res);
  };

  const VoucherDetailsHandler = async () => {
    setLoading(true);
    const id = { voucherId: voucherId };
    const voucherdetailData = await VoucherDetailsApi(id, () => {
      navigate("/");
    });
    setLoading(false);
    setVoucherdetail(voucherdetailData.res[0]);
  };

  const RelatedDealsHandler = async () => {
    const data = {
      voucherId: voucherId,
      business_id: 1,
    };
    const relateddealsData = await RelatedDealsApi(data, () => {
      navigate("/");
    });
    setRelateddeals(relateddealsData.res);
  };

  useEffect(() => {
    VoucherDetailsHandler();
    OtherDealsHandler();
    RelatedDealsHandler();
  }, []);

  //view More
  const [viewMore, setviewMore] = useState(false);
  const extraContent = (
    <div>
      <ul className="extra-content">
        {/* <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim. </li>
        <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim.  </li> */}
        {voucherdetail.about_business}
      </ul>
    </div>
  );
  const linkName = viewMore ? "View Less" : "View More";

  //read More
  const [readMore, setreadMore] = useState(false);
  const extraContentRead = (
    <div>
      <p className="extra-content">{voucherdetail.about_business}</p>
    </div>
  );
  const linkNameRead = readMore ? "Read Less" : "Read More";
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/my-account/my-vouchers">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <div className="my-3 inner-banner">
            <p className="banner-title">{voucherdetail.about_business}</p>
          </div>
          <Row className="pt-2">
            <Col md="6" className="vou-content">
              <Image loading="lazy" src={Contentimg} width="100%"></Image>
              <div className="tag-main">
                {/* ask */}
                <p className="ribben">COUPON</p>
              </div>
            </Col>
            <Col md="6">
              <p className="vou-title mb-3">{voucherdetail.voucher_title}</p>
              <p className="vou-about mb-3">
                <span className="vou-about-title">About this deal :</span>
                {voucherdetail.voucher_description}
              </p>
              <p className="vou-about-title">Terms & Conditions : </p>
              <ul>
                {/* <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim. </li>
            <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim.  </li> */}
                {voucherdetail.voucher_term_condition}
                {viewMore && extraContent}
                <p
                  className="read-more-link"
                  onClick={() => {
                    setviewMore(!viewMore);
                  }}
                >
                  {linkName}
                </p>
              </ul>
              <div className="d-flex mb-4">
                <p className="loc-price-1">
                  ${voucherdetail.voucher_actual_price}
                </p>
                <p className="loc-price-2">
                  ${voucherdetail.voucher_offer_price}
                </p>
                <p className="loc-price-offer">{voucherdetail.voucher_title}</p>
              </div>
              <Row>
                <Col md="6" className="text-center mb-2">
                  {voucherdetail.product_redeem_status === 0 ? (
                    <Link to={`/redeemconfirmation/${voucherId.toString()}`}>
                      <p className="green-btn">Redeem</p>
                    </Link>
                  ) : (
                    <p className="view-btn">Redeemed</p>
                  )}
                </Col>
                <Col md="6" className="text-center mb-2">
                  <Link>
                    <p className="view-btn">Share This Deal</p>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <p className="vou-about mt-4">
              <span className="vou-about-title">
                About {voucherdetail.about_business} :{" "}
              </span>{" "}
              Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling
              jide fökarad benim. Porade deneheten i operaosmos då memåska att
              agnostipod.
            </p>
            {readMore && extraContentRead}
            <p
              className="read-more-link mb-2"
              onClick={() => {
                setreadMore(!readMore);
              }}
            >
              {linkNameRead}
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">opening hours :</span>{" "}
              {voucherdetail.bup_open_time} am to {voucherdetail.bup_close_time}{" "}
              pm
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">Address :</span>{" "}
              {voucherdetail.bup_address1}, {voucherdetail.bup_address2}
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">Online :</span>{" "}
              www.kababhouse.com
            </p>
            <Link className="contact-btn">
              <p className="view">
                <MdCall /> Contact Seller
              </p>
            </Link>
          </Row>
          <div className="my-5">
            <Relateddeals
              id={voucherId}
              about_business={voucherdetail.about_business}
              relatedDealsList={relateddeals}
            />
          </div>
          <div className="my-5 other-deals-main">
            <OtherDeals id={voucherId} otherDealsList={otherdeals} />
          </div>
        </div>
      </div>
    </>
  );
};

export default VoucherDetails;
